import { MapPin, Clock, Mail, Phone, MessageCircle } from "lucide-react";
import { CLINIC, IMAGES, whatsappUrl } from "@/lib/clinic";

export default function Ubicacion() {
  return (
    <section
      id="ubicacion"
      data-testid="ubicacion-section"
      className="py-20 md:py-28 bg-cream"
    >
      <div className="section-container grid lg:grid-cols-12 gap-10 items-stretch">
        <div className="lg:col-span-6 rounded-[2rem] overflow-hidden relative min-h-[420px]">
          <img
            src={IMAGES.facade}
            alt="Fachada del instituto Salud Ocular en Paraná"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-900/55 via-navy-900/10 to-transparent" />
          <div className="absolute bottom-0 inset-x-0 p-8">
            <span className="inline-flex items-center gap-2 rounded-full bg-white/90 backdrop-blur px-4 py-1.5 text-[11px] tracking-[0.2em] uppercase font-semibold text-navy-900">
              <MapPin className="w-3.5 h-3.5 text-turquoise-600" /> Paraná · Entre Ríos
            </span>
          </div>
        </div>

        <div className="lg:col-span-6 flex flex-col justify-center">
          <span className="text-[11px] tracking-[0.24em] uppercase text-turquoise-700 font-semibold">
            Visitanos
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-navy-900 leading-tight">
            Estamos en el corazón de <span className="italic text-turquoise-700 font-light">Paraná</span>.
          </h2>
          <p className="mt-5 text-base text-navy-800/75 leading-relaxed max-w-md">
            Un espacio luminoso y accesible, diseñado para que cada visita sea cómoda desde el primer momento.
          </p>

          <ul className="mt-8 space-y-5">
            <li className="flex gap-4" data-testid="info-address">
              <div className="w-10 h-10 shrink-0 rounded-xl bg-turquoise-100 flex items-center justify-center text-turquoise-700">
                <MapPin className="w-5 h-5" strokeWidth={1.8} />
              </div>
              <div>
                <p className="text-[11px] tracking-[0.2em] uppercase text-navy-700/60 font-semibold">Dirección</p>
                <p className="text-navy-900 font-medium">{CLINIC.address}</p>
              </div>
            </li>
            <li className="flex gap-4" data-testid="info-schedule">
              <div className="w-10 h-10 shrink-0 rounded-xl bg-turquoise-100 flex items-center justify-center text-turquoise-700">
                <Clock className="w-5 h-5" strokeWidth={1.8} />
              </div>
              <div>
                <p className="text-[11px] tracking-[0.2em] uppercase text-navy-700/60 font-semibold">Horarios</p>
                <p className="text-navy-900 font-medium">{CLINIC.schedule}</p>
              </div>
            </li>
            <li className="flex gap-4" data-testid="info-email">
              <div className="w-10 h-10 shrink-0 rounded-xl bg-turquoise-100 flex items-center justify-center text-turquoise-700">
                <Mail className="w-5 h-5" strokeWidth={1.8} />
              </div>
              <div>
                <p className="text-[11px] tracking-[0.2em] uppercase text-navy-700/60 font-semibold">Email</p>
                <a
                  href={`mailto:${CLINIC.email}`}
                  className="text-navy-900 font-medium hover:text-turquoise-700"
                >
                  {CLINIC.email}
                </a>
              </div>
            </li>
            <li className="flex gap-4" data-testid="info-phone">
              <div className="w-10 h-10 shrink-0 rounded-xl bg-turquoise-100 flex items-center justify-center text-turquoise-700">
                <Phone className="w-5 h-5" strokeWidth={1.8} />
              </div>
              <div>
                <p className="text-[11px] tracking-[0.2em] uppercase text-navy-700/60 font-semibold">Teléfono</p>
                <p className="text-navy-900 font-medium">{CLINIC.phoneDisplay}</p>
              </div>
            </li>
          </ul>

          <a
            href={whatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="ubicacion-whatsapp-cta"
            className="mt-10 self-start inline-flex items-center gap-3 rounded-full bg-turquoise-500 hover:bg-turquoise-600 text-navy-900 px-7 py-4 text-base font-semibold transition-colors shadow-[0_10px_30px_-10px_rgba(43,181,154,0.6)]"
          >
            <MessageCircle className="w-5 h-5" strokeWidth={2.2} />
            Agendá tu turno por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
